/**
 * Team Hooks
 *
 * React Query hooks for team member operations.
 */

import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../lib/api';

export interface TeamMember {
  id: number;         // MySQL user ID (for display and auth)
  employeeId: number; // SQLite employee ID (for evaluations and tasks)
  name: string;
  email: string;
  role: string;
  active: boolean;
}

/**
 * Fetch team members for current manager
 */
async function fetchTeamMembers(): Promise<TeamMember[]> {
  return apiRequest<TeamMember[]>('/team');
}

/**
 * Hook to get team members
 */
export function useTeamMembers() {
  return useQuery({
    queryKey: ['team'],
    queryFn: fetchTeamMembers,
  });
}
